import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { RequestsService } from 'src/app/core/services/http/requests.service';
import { UntypedFormBuilder, UntypedFormGroup , Validators } from '@angular/forms';;
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../login.service';

import * as vo from '../../../core/model/server/vo/_index';
import { AuthService } from 'src/app/core/services/auth.service';
import { IdleWatcherService } from 'src/app/services/idle-watcher.service';
import { UserStatusCheckerService } from 'src/app/services/user-status-checker.service';
import { RbacService } from 'src/app/services/rbac.service';

// INTERFACES

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  show = true;
  logged_in = '';
  login_password_type = 'password';
  show_forgot = false;
  public loginForm: UntypedFormGroup;
  public sendForm: UntypedFormGroup;

  constructor(
    private route: Router,
    public userService: UserService,
    public request: RequestsService,
    private fb : UntypedFormBuilder,
    private toastr: ToastrService,
    private loginService: LoginService,
    private authService: AuthService,
    private idleWatcher: IdleWatcherService,
    private userStatusChecker: UserStatusCheckerService,
    private rbacService: RbacService,
  ) {
    this.loginForm = this.fb.group({
      username: [
        '',
        Validators.compose([
          Validators.required
        ])
      ],
      password: [
        '',
        Validators.compose([
          Validators.required
        ])
      ],
      rememberMe: [false], // unticked by default
    });
    this.sendForm = this.fb.group({
      username: [
        '',
        Validators.compose([
          Validators.required
        ])
      ],
      redirectUrl: [
        // 'http://localhost:4200/send-pass',
        // 'https://megapay-portal2-prod.web.app/send-pass',
        'https://megapay-portal-2.web.app/send-pass',
        Validators.compose([
          Validators.required
        ])
      ],
    });
  }

  ngOnInit(): void {
    console.log("LOGIN MODULE")
  }

  showLoginPassword(bool) {
    this.show = bool;
    // console.log('boolean', bool);
    if (bool) {
      this.login_password_type = 'text';
    } else {
      this.login_password_type = 'password';
    }
  }
  forgotPass(){
    this.show_forgot = !this.show_forgot
  }

  login() {
    const payload: vo.UserLoginRequest = {
      username: this.loginForm.controls.username.value,
      password: this.loginForm.controls.password.value
    };
    const rememberMe: boolean = this.loginForm.controls.rememberMe.value;

    this.loginService.login(payload.username, payload.password).subscribe({
      next: (response: vo.UserLoginResponse) => {
        if (response && response.result && response.result.sessionId) {
          this.loginService.saveLoginData(
            response,
            this.loginForm.controls.username.value,
            this.loginForm.controls.password.value
          );

          localStorage.setItem('rememberMe', String(rememberMe));

          this.rbacService.init();   
          this.userStatusChecker.startPolling();
          this.idleWatcher.start(rememberMe);

          const isAdmin = this.authService.isAdmin();

          if (isAdmin) {
            localStorage.setItem('navigate', '3');
            this.route.navigate(['/features/announcement']);
          } else {
            localStorage.setItem('navigate', '2');
            this.route.navigate(['/accounts']);
          }

          this.toastr.success('You have logged in successfully!', 'Success!');
        } else {
          this.toastr.error('Session ID not received', 'Error!');
        }
      },
      error: (err) => {
        this.toastr.error(err?.error?.message || 'Something went wrong!', 'Error!');
      }
    });
  }


  send(){
    this.loginService.sendForgotPasswordEmail(this.sendForm.controls.username.value, this.sendForm.controls.redirectUrl.value).then(response => {
        if (response.status === 200){
            this.toastr.success(response.message + '!', 'Success!');
            this.route.navigate(['/send-pass'])
        }
        else{
            this.toastr.error(response.error.message + '!', 'Something went Wrong')
        }
    })
  }
}
